export const PUFVProfessorPermissions = {
  id: 'pufv_professor',

  navbar: {
    view: true,
    profile: {
      edit: true,
      perfilBeta: false,
    },
  },

  projetos: {
    list: true,
    register: true,
    edit: true,
    approve: false,
    reprove: false,
    editFinished: false,
    remove: false,
    viewChecker: {
      professorGestor: false,
      coordenadorLocal: false,
    },
    filters: {
      situacao: true,
      coop: true,
    },
  },

  reembolsos: {
    list: false,
    register: false,
    edit: false,
    remove: false,
  },

  professores: {
    list: false,
    register: false,
    edit: false,
    approve: false,
    reprove: false,
    activate: false,
    deactivate: false,
    canRemove: false,
  },

  assessores: {
    list: false,
    register: false,
    edit: false,
    activate: false,
    deactivate: false,
    canRemove: false,
  },

  coordenadores: {
    list: false,
    register: false,
    edit: false,
    activate: false,
    deactivate: false,
    canRemove: false,
  },

  empresas: {
    list: false,
    register: false,
    edit: false,
    remove: false,
  },

  escolas: {
    list: false,
    register: false,
    edit: false,
    activate: false,
    deactivate: false,
    dadosDaEscola: {
      duplicate: false,
      edit: true,
      list: false,
      register: false,
      remove: true,
    },
    ideb: {
      list: false,
      register: false,
      edit: false,
      remove: false,
    },
  },

  relatorios: {
    generate: {
      projetos: false,
      'dados-cadastrais': false,
      'dados-gerais': false,
      'dados-do-programa': false,
      assessoria: false,
      'dados-do-ideb': false,
      contratos: false,
      escolas: false,
    },
  },

  agendaAssessoresPedagogicos: {
    list: false,
    register: false,
    edit: {
      locked: false,
      unlocked: false,
    },
    lock: false,
    unlock: false,
    remove: [false, false, false, false, false],
  },

  materiaisPedagogicos: {
    list: true,
    download: true,
  },

  dashboard: {
    generate: false,
  },

  contratos: {
    list: false,
    editEvenWhenDisabled: false,
    assessor: {
      allStatus: [],
      edit: false,
      register: false,
      view: false,
      upload: false,
      changeUpload: false,
      changeStatus: false,
      analiseOperacional: {
        edit: false,
      },
      templates: {
        list: false,
        edit: false,
      },
    },
    entePublico: {
      allStatus: [],
      downloadChecklist: false,
      edit: false,
      register: false,
      view: false,
      uploadNaoAssinado: false,
      uploadAssinado: false,
      uploadExtrato: false,
      changeUploadAssinado: false,
      changeUploadExtrato: false,
      changeUploadPlanoTrabalho: false,
      changeStatus: false,
      analiseOperacional: {
        edit: false,
      },
    },
    entePrivado: {
      allStatus: [],
      edit: false,
      register: false,
      view: false,
      upload: false,
      changeUpload: false,
      changeStatus: false,
      analiseOperacional: {
        edit: false,
      },
      templates: {
        list: false,
        edit: false,
      },
    },
  },
};
